import { useQuery } from "@tanstack/react-query";

import {
  getPartnersMediaFiles,
  type PartnerMediaFileSortColumn,
  type SortOrder,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { MEDIA_FILES_QUERY_KEYS } from "./queryKeys";

interface UseMediaFilesQueryParams {
  offset?: number;
  limit?: number;
  searchQuery?: string | null;
  sortBy?: PartnerMediaFileSortColumn;
  sortOrder?: SortOrder;
}

export function useMediaFilesQuery(params?: UseMediaFilesQueryParams) {
  const { offset, limit, searchQuery, sortBy, sortOrder } = params ?? {};

  return useQuery({
    queryKey: MEDIA_FILES_QUERY_KEYS.list(
      offset,
      limit,
      searchQuery,
      sortBy,
      sortOrder,
    ),
    queryFn: processResponse(() =>
      getPartnersMediaFiles(offset, limit, searchQuery, sortBy, sortOrder),
    ),
  });
}
